import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StaticMessage } from '@shared/enums';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  staticMessage = StaticMessage;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      extra?: string;
      title: string;
      message: string;
      buttonLabel: string;
      buttonColor?: string;
      buttonIcon?: string;
      cancelButtonLabel: string;
      hideCancelButton?: boolean;
      displayCloseButton?: boolean;
      hideAllButtons?: boolean;
    }
  ) {}
}
